// extracted by mini-css-extract-plugin
module.exports = {"cyan200":"#6ecacd","coral500":"#e9645d"};